import React from 'react';
import xor from 'lodash/xor';

export { default as callOrReturn } from './callOrReturn';

export function normalizeColumns(elements) {
  const columns = [];
  React.Children.forEach(elements, element => {
    if (!React.isValidElement(element)) {
      return;
    }
    const column = { ...element.props };
    if (element.key) {
      column.key = element.key;
      columns.push(column);
    }
  });
  return columns;
}

export function arrayHasSameValues(array0, array1) {
  return xor(array0, array1).length === 0;
}

export function arrayAddValue(array, value) {
  if (!array.includes(value)) {
    array.push(value);
  }
}

export function arrayRemoveValue(array, value) {
  const index = array.indexOf(value);
  if (index > -1) {
    array.splice(index, 1);
  }
}

export function unflatten(array, parent = { id: null }, dataKey = 'id', parentKey = 'parentId') {
  const tree = array.filter(x => x[parentKey] === parent[dataKey]).map(x => ({ ...x }));

  tree.forEach(child => {
    const childTree = unflatten(array, child, dataKey, parentKey);
    if (childTree.length > 0) child.children = childTree;
  });

  return tree;
}
